import React from 'react';
import {VerifyContactDialogView} from 'features/contact-verification/VerifyContactDialogView';
import {VerifyContactDialogPayload} from 'features/contact-verification/useCustomerContact';
import {useDialog} from 'hooks';

export const VerifyContactDialog: React.FC = () => {
  const dialog = useDialog<VerifyContactDialogPayload>('verify-contact');

  if (!dialog.open || !dialog.state) return null;
  const {channel, intro, onResolved} = dialog.state;

  return (
    <VerifyContactDialogView
      channel={channel}
      intro={intro}
      onClose={() => {
        onResolved({status: 'cancelled'});
        dialog.onClose();
      }}
      onVerified={(verifiedValue) => {
        onResolved({status: 'verified', verifiedValue});
        dialog.onClose();
      }}
    />
  );
};
